import React from 'react';
import { Note } from './styled';

export const Disclaimer: React.FC = () => (
  <Note>
    <strong>NOTA: </strong>
      Recuerda que la publicación del aviso impreso está sujeto al pago antes de la fecha de cierre de la edición seleccionada. Asimismo, si el pago se da después del horario de cierre, el aviso se publicará en la siguiente fecha más cercana. Para el caso de ediciones de Sábados y Domingos fuera de la fecha de cierre, la fecha de publicación será la siguiente semana más cercana. Ten en cuenta que una vez realizado el pago de tu aviso, este no podrá ser editado. 
  </Note>
);
